import React from "react";

// ConfirmDialog component with Tailwind CSS
function ConfirmDialog({ message, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
        <p className="text-lg mb-4 text-gray-700 font-semibold ">{message}</p>
        <div className="flex justify-between">
          <button
            className="bg-blue-500 text-white rounded-sm py-2 px-8 hover:bg-blue-600 transition duration-300"
            onClick={onConfirm}
          >
            Yes
          </button>
          <button
  className="bg-white text-black rounded-sm py-2 px-8 hover:bg-blue-500 hover:text-white transition duration-300 ring-1 ring-blue-500"
            onClick={onCancel}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
